import { EDatePickerMode } from '../../enum'

// Create a union type of all possible values from the enum
type IDatePickerModeLangKey = `${EDatePickerMode}`

export type IDatePickerModeLang = {
	date_picker_mode: Record<IDatePickerModeLangKey, string>
}

const langEntries = Object.entries(EDatePickerMode).map(
	([key, value]) => [value, `date_picker_mode.${value}`]
)

const langObj: Record<IDatePickerModeLangKey, string> = Object.fromEntries(langEntries)

export const DATE_PICKER_MODE_LANG_KEY: IDatePickerModeLang = {
	date_picker_mode: langObj
}
